import React, { useEffect, createElement } from 'react';
import LandingPage from './components/LandingPage';
const GTM_ID = 'GTM-MPQRBHMJ';
function App() {
  useEffect(() => {
    // Set the browser tab title and meta description
    document.title = 'Standard Consulting | Auditoría, Consultoría y Asesoría Contable';
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = 'Transformamos la información financiera en confianza, transparencia y decisiones estratégicas. Agenda tu diagnóstico financiero gratuito.';
  }, []);
  useEffect(() => {
    // Avoid injecting twice (e.g. during hot reloads)
    if (document.getElementById('gtm-script')) return;
    // <head> script
    const script = document.createElement('script');
    script.id = 'gtm-script';
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`;
    document.head.appendChild(script);
    // <body> noscript iframe fallback
    const noscript = document.createElement('noscript');
    noscript.id = 'gtm-noscript';
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }, []);
  return <LandingPage data-id="element-0" data-mp="nv0xxsp64o55" />;
}
export { App };